import React from 'react';
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import {ThemeProvider} from '@material-ui/core/styles'
import {generarTema} from './componentes/layout/Tema'
import AuthProvider  from './componentes/context/AuthContext';
import GeneralesProvider from './componentes/context/GeneralesContext';
import ClienteProvider from './componentes/context/ClienteContext';
import Contenedor from './componentes/layout/Contenedor'
import Login from './componentes/auth/Login'
import { ToastContainer } from 'react-toastify';
import PerfilInicio from './componentes/perfiles/PerfilInicio';
import Usuario from './componentes/usuario/UsuarioInicio'
import SugerenciaPublico from './componentes/SugerenciaPub';
import Apoyo from './componentes/Apoyo/Apoyo'
import Recorrido from './componentes/Recorrido'
import MapaSecciones from './componentes/mapa'
import Incidencia from './componentes/incidencias';
import Estructura from './componentes/estructura';
import Prep from './componentes/prep';
import Organizacion from './componentes/Organizacion';
import AvanceGeneral  from './componentes/AvGeneral';
import LimpiaCache from './componentes/LimpiaCache';
import Notificacion from './componentes/Notificacion';
import PublicoInicio from './componentes/publico';
import RepoSudoku from './componentes/repoSudoku';
import AvanceSolicitud from './componentes/AvSugerencia';
import 'react-toastify/dist/ReactToastify.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import Asistencia from './componentes/Asistencia';
import Afiliado from './componentes/Afiliado'
import SondeoInicio from './componentes/Sondeo/PerfilInicio';
import ReporteEncuesta from './componentes/RepoEncuesta';
import ReporteAvance from './componentes/RepoAvance';
import MapaSvg from './componentes/EncuestasSvg/PerfilInicio';
import MapaPoligono from './componentes/MapaPoligonos';
import Publico from './componentes/publico-reg';
import PublicoReg from './componentes/publico-reg';
import MapaDto from './componentes/MapaPoliDto';
import ReporteEncuestado from './componentes/RpEncuestado';
import MapaEncuesta from './componentes/Mapa-Encuesta';
import Minutas from './componentes/Minutas';
import MinutasSolicitud from './componentes/Minutas-solicitud';
import MapaRuta from './componentes/MapaRutas';
import MapaRecorrido from './componentes/MapaRecorridos';

function App() {
  const [colorTema,setColorTema] = React.useState(false);
  React.useEffect(()=>{
    const auxColor= localStorage.getItem('ColorTheme');
    if ( auxColor===undefined || auxColor===null) 
    {
      localStorage.setItem('ColorTheme',colorTema);
    //  console.log("sin el tema");
    }
    else
    {  //console.log("cargando el tema");
      //console.log(JSON.parse(auxColor));
      setColorTema(JSON.parse(auxColor))    
    }
  },[])

  return (
  <React.Fragment >
    <AuthProvider>
      <GeneralesProvider>
        <ClienteProvider>
        <Router>
          <ThemeProvider theme={generarTema(colorTema)}>
            <Contenedor colorTema={colorTema} setColorTema={setColorTema}>              
              <Switch>
                <Route exact path="/" component={Login}  />     
                <Route exact path="/lista-x-subdistrito" component={MapaSvg}  />     
                <Route exact path="/reporte-encuesta" component={ReporteEncuesta}  />     
                <Route exact path="/reporte-encuesta-individual" component={ReporteEncuestado}  />    
                <Route exact path="/reporte-avance" component={ReporteAvance}  />    
                <Route exact path="/afiliado" component={Afiliado}  />
                <Route exact path="/sondeo" component={SondeoInicio}  />
                <Route exact path="/lista-promovido" component={PerfilInicio}  />
                <Route exact path="/lista-publico" component={PublicoInicio}  />                   
                <Route exact path="/lista-Usuario" component={Usuario}  />                                   
                <Route exact path="/solicitudes-atencion" component={SugerenciaPublico}  />   
                <Route exact path="/publico" component={PublicoReg}  />   
                <Route exact path="/apoyo" component={Apoyo}  />  
                <Route exact path="/asistencia" component={Asistencia}  />  
                <Route exact path="/recorrido" component={Recorrido}  />                
                <Route exact path="/mapa-secc" component={MapaSecciones}  />
                <Route exact path="/incidencia" component={Incidencia}  />
                <Route exact path="/estructura" component={Estructura}  />
                <Route exact path="/prep" component={Prep}  />                                            
                <Route exact path="/organizacion" component={Organizacion}  /> 
                <Route exact path="/avance-general" component={AvanceGeneral}  /> 
                <Route exact path="/avance-solicitud" component={AvanceSolicitud}  /> 
                <Route exact path="/limpiar-cache" component={LimpiaCache}  /> 
                <Route exact path="/notificacion" component={Notificacion}  /> 
                <Route exact path="/mapa-poligono" component={MapaPoligono}  /> 
                <Route exact path="/mapa-recorrido" component={MapaRecorrido}  /> 
                <Route exact path="/otb-recintos" component={MapaDto}  /> 
                <Route exact path="/mapa-encuesta" component={MapaEncuesta}  /> 
                <Route exact path="/minutas-activ" component={Minutas}  /> 
                <Route exact path="/minutas-solic" component={MinutasSolicitud}  /> 
                <Route exact path="/mapa-ruta" component={MapaRuta}  /> 
                <Route exact path="/carga-total" component={RepoSudoku}  /> 
               {/* */}
                <Route path="*" component={  Login } />
              </Switch>              
            </Contenedor>
          </ThemeProvider>
          <ToastContainer autoClose={5000} closeOnClick/>
        </Router>
        </ClienteProvider>
      </GeneralesProvider>
    </AuthProvider>
  </React.Fragment>
  );
}

export default App;